import React from 'react';

import { BrandLogo, makeUclComponent } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { spacing } from 'styles/constants';

type PictureContainerProps = BoxProps & {
  inverted?: boolean;
};

const styles = StyleSheet.create({
  pictureContainer: {
    minHeight: spacing.$6,
    minWidth: spacing.$32,
  },
});

const PictureContainerBase = ({ inverted: _inverted, style, ...props }: PictureContainerProps) =>
  React.createElement(Box, { ...props, style: [styles.pictureContainer, style] });

export const PictureContainer = makeUclComponent(PictureContainerBase);

export const DefaultLoyaltyLogo = BrandLogo.withConfig({
  padding: 0,
});
